import { render, staticRenderFns } from "./FormatBold.vue?vue&type=template&id=8b3cf758&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatBold.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/FormatBold.vue
// module id = 2304
// module chunks = 1